import { useId } from 'react';
import type { ListenMode } from '@jabberr/core';
import { TALK_MODES, talkModeHint, talkModeToListenMode } from '../lib/plain.js';

/**
 * "When Jabberr talks": Always / When named / Keen / Silent. Silent records the transcript without spoken replies.
 */
export function TalkModeControl({
  value,
  onChange,
  busy = false,
  showHint = false,
  className = '',
}: {
  value: ListenMode;
  onChange: (mode: ListenMode) => void;
  busy?: boolean;
  showHint?: boolean;
  className?: string;
}) {
  const name = useId();
  return (
    <fieldset className={`talk-modes ${className}`}>
      <legend className="sr-only">When Jabberr talks</legend>
      {TALK_MODES.map((opt) => {
        const mode = talkModeToListenMode(opt.mode);
        const checked = mode !== null && mode === value;
        return (
          <label key={opt.mode} className={`talk-mode ${checked ? 'active' : ''}`} title={opt.hint}>
            <input
              type="radio"
              name={name}
              value={opt.mode}
              checked={checked}
              disabled={busy}
              onChange={() => {
                if (mode && mode !== value) onChange(mode);
              }}
            />
            <span>{opt.label}</span>
          </label>
        );
      })}
      {showHint ? <span className="talk-mode-hint">{talkModeHint(value)}</span> : null}
    </fieldset>
  );
}
